import {
  LanguageId,
  useArticleLinkLookupQuery,
} from 'lib-knowledge-management-common/graphql';

type UseArticleLinkLookupResult = ReturnType<typeof useArticleLinkLookupQuery>;

export function useArticleLinkLookup({
  collectionId,
  searchValue,
  skip,
  languageId,
}: {
  collectionId: string | null;
  searchValue: string;
  skip: boolean;
  languageId?: LanguageId;
}): UseArticleLinkLookupResult {
  const res = useArticleLinkLookupQuery({
    variables: {
      languageId: languageId ?? LanguageId.En,
      filters: {
        collectionId: [collectionId].filter(Boolean) as string[],
        excludeOrphans: true,
      },
      query: {
        searchLanguage: languageId ?? LanguageId.En,
        searchTerms: searchValue,
      },
    },
    fetchPolicy: 'network-only',
    skip: skip || !collectionId || searchValue.length === 0,
  });

  return res;
}
